var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"flex items-center gap-7 overflow-x-auto"},_vm._l((_vm.navigationItems),function(nav){return _c('li',{key:nav.name},[_c('router-link',{staticClass:"nav-tab",attrs:{"to":nav.to,"active-class":"is-active"}},[_vm._v(" "+_vm._s(_vm.$t(nav.name))+" ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }